<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-INTEGRITY-TOOLS' : 'EDIT-INTEGRITY-TOOLS') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm">
        <kendo-tabstrip #tabstrip>
            <kendo-tabstrip-tab title="{{ 'INTEGRITY-TOOLS-BATCH' | translate }}" [selected]="true">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <!--Integrity Type-->
                        <div class="col-12 pl-0">
                            <label class="k-form-field">
                                <span class="k-text-uppercase dark">
                                    {{'INTEGRITY-TYPE' | translate}} *
                                </span>
                                <div>
                                    <kendo-combobox [filterable]="false" formControlName="integrityType"
                                        [data]="integrityTypes" [textField]="'label'" [valueField]="'value'"
                                        [valuePrimitive]="true" class="w-50">
                                    </kendo-combobox>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="integrityType.hasError('required') && integrityType.touched">
                                        {{'REQUIRED-INTEGRITY-TYPE' | translate}}
                                    </div>
                                </div>
                            </label>
                        </div>
                        <!--Comments-->
                        <div class="row">
                            <div class="col-12">
                                <label for="comments" class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{ 'COMMENTS' | translate }}
                                    </span>
                                    <textarea kendoTextArea class="w-100" rows="3" formControlName="comments"
                                        maxlength="4000">
                                      </textarea>
                                </label>
                            </div>
                        </div>
                        <!--Options-->
                        <div class="row mt-3">
                            <div class="col-6">
                                <input id="automaticDiscardOnError" type="checkbox"
                                    formControlName="automaticDiscardOnError" kendoCheckBox>
                                <label class="k-checkbox-label k-text-uppercase dark" for="automaticDiscardOnError"
                                    [ngClass]="{'k-disabled': automaticDiscardOnError.disabled}">{{
                                    'AUTOMATIC-DISCARD-ON-ERROR' | translate}}
                                </label>
                            </div>
                            <div class="col-6">
                                <input id="automaticValidations" type="checkbox" formControlName="automaticValidations"
                                    kendoCheckBox>
                                <label class="k-checkbox-label k-text-uppercase dark" for="automaticValidations"
                                    [ngClass]="{'k-disabled': automaticValidations.disabled}">{{ 'AUTOMATIC-VALIDATIONS'
                                    |
                                    translate}}</label>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <!--Address Validations selections-->
            <kendo-tabstrip-tab
                *ngIf="integrityType && (integrityType.value === 'ADDRESS_MEMBER' || integrityType.value === 'ADDRESS_CARE_TEAM')"
                title="{{ 'INTEGRITY-TOOLS-TAB-SELECTIONS' | translate }}">
                <ng-template kendoTabContent>
                    <div class="k-form">
                        <div class="row ">
                            <div class="col-3 apl-0">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'USERS-SELECTION' | translate}} *
                                    </span>
                                </label>
                            </div>
                            <div class="col-9 mt-2">
                                <input type="radio" value="ALL" name="userSelection" formControlName="userSelection"
                                    id="radUserAll" kendoRadioButton />
                                <label class="k-radio-label" for="radUserAll" [ngClass]="{'k-disabled': isLocked}">{{
                                    'USERS-SELECTION-ALL' |
                                    translate}}
                                </label>
                                <input type="radio" value="ADDED_BY" name="userSelection"
                                    formControlName="userSelection" id="radUserAddedBy" kendoRadioButton />
                                <label class="k-radio-label" for="radUserAddedBy"
                                    [ngClass]="{'k-disabled': isLocked}">{{'USERS-SELECTION-ADDED-BY'
                                    |
                                    translate}}
                                </label>
                                <input type="radio" value="MODIFIED_BY" name="userSelection"
                                    formControlName="userSelection" id="radUserModifiedBy" kendoRadioButton />
                                <label class="k-radio-label" for="radUserModifiedBy"
                                    [ngClass]="{'k-disabled': isLocked}">{{'USERS-SELECTION-LAST-MODIFIED-BY'
                                    | translate}}
                                </label>
                                <input type="radio" value="ADDED_MODIFIED_BY" name="userSelection"
                                    formControlName="userSelection" id="radUserAddedModified" kendoRadioButton />
                                <label class="k-radio-label" for="radUserAddedModified"
                                    [ngClass]="{'k-disabled': isLocked}">{{'USERS-SELECTION-ADDED-MODIFIED-BY'
                                    | translate}}
                                </label>
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                    *ngIf="userSelection.hasError('required') && userSelection.touched">
                                    {{'REQUIRED-USERS-SELECTION' | translate}}
                                </div>
                            </div>
                        </div>
                        <kendo-card class="w-100 mt-2"
                            *ngIf="userSelection?.value !== '' && userSelection?.value !== 'ALL'">
                            <kendo-card-body class="pt-1 pb-3">
                                <!--Users-->
                                <div class="row">
                                    <div class="col-12">
                                        <label for="users" class="k-form-field">
                                            <span class="k-text-uppercase dark">
                                                {{ 'USERS' | translate }}
                                            </span>
                                            <kendo-multiselect [data]="usersFiltered" formControlName="users"
                                                class="max-height" [textField]="'name'" [filterable]="true"
                                                [valueField]="'id'" (filterChange)="filterUsers($event)"
                                                (close)="searchTerm=''" [itemDisabled]="userItemDisabled"
                                                [autoClose]="true" [virtual]="virtualUser">
                                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                                    </span>
                                                </ng-template>
                                            </kendo-multiselect>
                                        </label>
                                    </div>
                                </div>
                                <!--Organizations-->
                                <div class="row">
                                    <div class="col-12">
                                        <label for="organizations" class="k-form-field">
                                            <span class="k-text-uppercase dark">
                                                {{ 'ORGANIZATIONS' | translate }}
                                            </span>
                                            <kendo-multiselect [data]="organizationsFiltered"
                                                formControlName="organizations" class="max-height" [textField]="'name'"
                                                [filterable]="true" [valueField]="'id'"
                                                (filterChange)="filterOrganizations($event)" (close)="searchTerm=''"
                                                [autoClose]="true" [virtual]="virtualOrganization"
                                                [itemDisabled]="itemDisabled">
                                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                                    </span>
                                                </ng-template>
                                            </kendo-multiselect>
                                        </label>
                                    </div>
                                </div>
                                <!--From/To date-->
                                <div class="row">
                                    <div class="col-6 mt-3">
                                        <kendo-daterange>
                                            <kendo-floatinglabel text="{{'FROM' | translate}}" *
                                                class="k-text-uppercase dark">
                                                <kendo-dateinput kendoDateRangeStartInput
                                                    formControlName="fromDateSelection">
                                                </kendo-dateinput>
                                            </kendo-floatinglabel>
                                            <kendo-floatinglabel text="{{'TO' | translate}}" *
                                                class="k-text-uppercase dark">
                                                <kendo-dateinput kendoDateRangeEndInput
                                                    formControlName="toDateSelection">
                                                </kendo-dateinput>
                                            </kendo-floatinglabel>
                                        </kendo-daterange>
                                    </div>
                                </div>
                            </kendo-card-body>
                        </kendo-card>
                        <!--Last name starts with-->
                        <div class="row">
                            <div class="col-12">
                                <label class="k-form-field">
                                    <span class="k-text-uppercase dark">
                                        {{'INTEGRITY-LAST-NAME-SELECTION' | translate}}
                                    </span>
                                    <input id="lastNameSelection" kendoTextBox formControlName="lastNameSelection"
                                        maxlength="100" />
                                </label>
                                <small class="form-text text-muted">{{ 'INTEGRITY-LAST-NAME-EXAMPLE' |
                                    translate}}
                                </small>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
        <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
    </form>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ (isLocked ? 'CLOSE' : 'CANCEL') | translate }}</button>
        <button *ngIf="!isLocked" appPreventClick class="k-button k-primary"
            [disabled]="!editForm.valid || !editForm.dirty || saving" (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>